export default __webpack_public_path__ + "static/dekoder-black-slogan-c0f8280db40594a9165ac8c58bb4b5e0.svg";